/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    LinearProgress
} from "@material-ui/core";
import { toast } from "helpers/apiRequests";
import { createMember } from "../../../../redux/actions/tmail";
import { useDispatch } from 'react-redux';
import MultiSelectableItem from '../utility/MultiSelect';

const CreateMemberModal = ({ openModal, handleClose, spaceMembers, appId }) => {
    const dispatch = useDispatch();
    const [selectedMember, setSelectedMember] = useState([]);
    const [role, setRole] = useState();
    const [saveLoading, setSaveLoading] = useState(false);

    const handleClose_ = () => {
        handleClose()
    }

    const handleRoleChange = (e) => {
        const val = e.target.value;
        setRole(val);
        const members = [...selectedMember];
        const newMembers = members.map(member => {
            member.role = val;
            return member;
        });
        setSelectedMember(newMembers);
    }

    const changeIsLoadingSaveApp = () => {
        setSaveLoading(false)
    }

    const createNewMember = e => {
        e.preventDefault();
        setSaveLoading(true);
        if (selectedMember.length === 0) {
            toast.notify("Please select a workspace member", { type: "info" });
            setSaveLoading(false)
            return
        } else if (role === "") {
            toast.notify("Please select a role for the members selected", { type: "info" });
            setSaveLoading(false)
            return
        }

        const payload = {
            tmail_app_id: appId,
            podio_users: selectedMember
        };
        dispatch(createMember(payload, changeIsLoadingSaveApp, handleClose_));
        setSelectedMember([]);
    }

    const options = spaceMembers.length > 0 ? spaceMembers.map(space => {
        return {
            value: space.user_id,
            label: `${space.name}`
        }
    }) : null;

    const memberChangeHandler = (val) => {
        const selectVals = val;
        const members = selectVals.map(mem => {
            const member = spaceMembers.find(space => space.user_id === mem.value);
            if (member) {
                if (role !== '') {
                    member.role = role;
                }
                return member;
            }
            return null;
        })
        const addedMembers = members.filter(memb => memb != null);
        setSelectedMember(addedMembers);
    };


    return (
        <div >
            <Dialog
                open={openModal}
                onClose={handleClose}
                disableEscapeKeyDown={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                id="connector-modal"
                maxWidth="md"
            >
                <div style={{ width: "700px" }}>
                    <DialogContent >
                        <DialogContent>
                            <h5 className='mb-3'>Add Workspace Member</h5>
                            <div className="row justify-content-center">
                                <div className="col-md-12">
                                    <div className="form-row">
                                        <div className="form-group col-md-2">
                                            <label
                                                style={{
                                                    fontSize: "15px",
                                                    marginTop: "5px"
                                                }}>
                                                Workspace Members:
                                            </label>
                                        </div>
                                        <div className="form-group col-md-10">
                                            <MultiSelectableItem
                                                placeholder="Select Members"
                                                options={options}
                                                handleChange={memberChangeHandler}
                                            />
                                        </div>

                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-2">
                                            <label
                                                style={{
                                                    fontWeight: "normal",
                                                    fontSize: "15px",
                                                    marginTop: "5px"
                                                }}>
                                                Assign Role:
                                            </label>
                                        </div>
                                        <div className="form-group col-md-10">
                                            <select
                                                className='form-control'
                                                value={role}
                                                onChange={handleRoleChange}
                                            >
                                                <option>Select Role</option>
                                                <option value="admin">Admin</option>
                                                <option value="member">Member</option>
                                            </select>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="mt-2">
                                {
                                    saveLoading ? <center className="mt-3">
                                        <LinearProgress />
                                    </center> : null
                                }
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="">
                                    <Button id="button-cancel" onClick={handleClose_} color="primary">
                                        Close
                                    </Button>
                                </div>
                                <div className="">
                                    <button
                                        type='button'
                                        onClick={createNewMember}
                                        style={{
                                            color: "#fff",
                                            background: "#F7C948",
                                        }}
                                        className="btn btn-default"
                                    >Add members</button>
                                </div>
                            </div>

                        </DialogContent>


                    </DialogContent>

                </div>
            </Dialog>
        </div>
    )

}
export default CreateMemberModal